import { atom } from "recoil";
export const openAddUpdatePatientModalOthersState = atom({
    key: "openAddUpdatePatientModalOthers",
    default:
        /** @type {{ open: boolean; userMobile?: string; type?: string; patientDetails?: any; appointmentIndex?: number | null }} */ ({
            open: false,
            userMobile: "",
            type: "",
            patientDetails: null,
            appointmentIndex: null,
        }),
});
export const patientRefetchState = atom({
    key: 'patientRefetchState',
    default: false,
});